import { CSpinner } from './CSpinner.js';

const CSpinnerPlugin = {
    install: (app) => {
        app.component(CSpinner.name, CSpinner);
    },
};

export { CSpinner, CSpinnerPlugin };
//# sourceMappingURL=index.js.map
